/* eslint-disable @typescript-eslint/no-var-requires */
// Typed view over the CommonJS whitelist. The module itself has to stay JS so
// next.config.js can require it -- see translatedRoutes.js.
const { translatedRoutes, isTranslatedRoute, normalizePathname } =
  require("./translatedRoutes") as {
    translatedRoutes: string[];
    isTranslatedRoute: (pathname: string) => boolean;
    normalizePathname: (pathname: string) => string;
  };

export { translatedRoutes, isTranslatedRoute, normalizePathname };
